import {SearchBarController} from './controllers/searchBarController';
import './styles/searchBar.scss';

export class SearchBarDirective implements angular.IDirective {
    restirct = 'E';
    template = require('./templates/searchBar.html');
    controller = SearchBarController;
    controllerAs = 'vm';
    bindToController = {
        searchTerm: '=searchTerm',
        isSearchOpen: '=isSearchOpen',
        isSearching: '=isSearching'
    };
    scope = {};
    
    static factory(): angular.IDirectiveFactory {
        return () => new SearchBarDirective();
    }
}

angular.module('deliveryCreate.app').directive('searchBar', SearchBarDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/searchBar/searchBarDirective.ts
 **/